// extracted by mini-css-extract-plugin
export var banner = "_fi-0";
export var closeButton = "_fi-2";
export var greenCheckmark = "_fi-3";
export var hereLink = "_fi-4";
export var titleIcon = "_fi-1";